import { initializeApp, getApps } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";

const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;

const app = getApps()[0] || initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain,
  projectId: authDomain.split(".")[0],
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
});

export const auth = getAuth(app);
auth.useDeviceLanguage();
setPersistence(auth, browserLocalPersistence);
// Automated tests on the preview site only; works solely with Firebase fictional test numbers.
if (window.location.hostname.endsWith(".preview.emergentagent.com") && localStorage.getItem("ww_e2e") === "1") {
  auth.settings.appVerificationDisabledForTesting = true;
}

const MESSAGES = {
  "auth/invalid-credential": "Incorrect email or password.",
  "auth/wrong-password": "Incorrect email or password.",
  "auth/user-not-found": "Incorrect email or password.",
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/email-already-in-use": "Could not create an account with this email. Try signing in or resetting your password.",
  "auth/weak-password": "Use at least 8 characters with letters and numbers.",
  "auth/password-does-not-meet-requirements": "Use at least 8 characters with letters and numbers.",
  "auth/too-many-requests": "Too many attempts. Please wait a few minutes and try again.",
  "auth/invalid-verification-code": "That code is incorrect. Please check and try again.",
  "auth/code-expired": "This code has expired. Please request a new one.",
  "auth/invalid-phone-number": "Please enter a valid mobile number.",
  "auth/quota-exceeded": "SMS limit reached for now. Please try again later or use Email or Google.",
  "auth/operation-not-allowed": "This sign-in method isn't available in your country yet. Please use Email or Google.",
  "auth/popup-closed-by-user": "Google sign-in was closed before finishing.",
  "auth/cancelled-popup-request": "Google sign-in was closed before finishing.",
  "auth/popup-blocked": "Your browser blocked the Google window. Please allow pop-ups and try again.",
  "auth/account-exists-with-different-credential": "An account already uses this email with a different sign-in method. Sign in that way, then link Google from Account.",
  "auth/credential-already-in-use": "This sign-in method is already connected to a different Warranty Wallet account.",
  "auth/provider-already-linked": "This sign-in method is already connected to your account.",
  "auth/requires-recent-login": "For your security, please sign in again and retry.",
  "auth/network-request-failed": "Network problem. Please check your connection and try again.",
  "auth/captcha-check-failed": "Security check failed. Please refresh the page and try again.",
  "auth/invalid-app-credential": "Security check failed. Please refresh the page and try again.",
  "auth/missing-app-credential": "Security check failed. Please refresh the page and try again.",
  "auth/unauthorized-domain": "Sign-in isn't enabled on this web address yet. Please use warrantywallet.in.",
  "auth/missing-phone-number": "Please enter your mobile number.",
  "auth/missing-verification-code": "Please enter the 6-digit code.",
  "auth/invalid-verification-id": "This code request has expired. Please request a new code.",
  "auth/session-expired": "This code has expired. Please request a new one.",
  "auth/billing-not-enabled": "Mobile sign-in by SMS isn't switched on yet. Please use Email or Google for now.",
  "auth/admin-restricted-operation": "This sign-in method isn't available right now. Please use Email or Google.",
  "auth/user-disabled": "This account has been disabled. Please contact support@warrantywallet.in.",
  "auth/web-storage-unsupported": "Please enable cookies and site storage in your browser to sign in.",
};

export const authError = (e) => MESSAGES[e?.code] || "Something went wrong. Please try again.";
